import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import FeaturedTable from '../../../FeaturedTable/FeaturedTable'
import Loader from '../../../Loader/Loader'

import { useGetBuildingNumber } from './hooks'
import { chatSystemNumberTableColumns, chatSystemNumberTableRows } from './utils'

const SectionSystemNumbers = ({ buildingId, timezone, handleActionSystemInbox }) => {
  const { t } = useTranslation(['chat'])
  const { data, isLoading } = useGetBuildingNumber(buildingId)

  return (
    <React.Fragment>
      <div className="inbox__settings-navbar">
        <div className="left-side">{t('chat:inboxSettings.systemsNumbers')}</div>
      </div>
      {isLoading ? (
        <div className="inbox__settings-loader">
          <Loader className="loader" />
        </div>
      ) : (
        <div className="inbox__settings-body">
          <div className="inboxes-main-table">
            <FeaturedTable
              columns={chatSystemNumberTableColumns(timezone, handleActionSystemInbox)}
              data={chatSystemNumberTableRows(data)}
            />
          </div>
        </div>
      )}
    </React.Fragment>
  )
}

SectionSystemNumbers.propTypes = {
  buildingId: PropTypes.number,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      Header: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
      Cell: PropTypes.oneOfType([PropTypes.func]),
      accessor: PropTypes.string,
    }),
  ),
  timezone: PropTypes.string,
  handleActionSystemInbox: PropTypes.func,
}

export default SectionSystemNumbers
